// Copyright (c) StrangeBee 2023

import { AdminPermissions, OrgPermissions, AllPermissions } from 'thehive-sdk';
import { useCurrentUser } from '@Queries/userQueries';
import usePermissions from '@Hooks/usePermissions';

interface UseUserPermissionsInterface {
    permissionsNeeded: AdminPermissions[] | OrgPermissions[] | AllPermissions[];
}

const useUserPermissions = ({ permissionsNeeded = [] }: UseUserPermissionsInterface): boolean => {
    const { data: currentUser } = useCurrentUser();
    const { permissions = [] } = currentUser || {};
    const hasPermissions = usePermissions({ permissionsNeeded, permissionsList: permissions });

    return hasPermissions;
};

export default useUserPermissions;
